module.exports = __webpack_public_path__ + "media/images/new-ui-images/receipt-icon-22d2341de587bebfd4e2f3008b6e0ac9.svg";